//import("../../node_modules/dragdealer/src/dragdealer.js");
//import("../../node_modules/paroller.js/dist/jquery.paroller.js");
//import("../../node_modules/stickybits/dist/stickybits.min.js");

import Dragdealer from 'dragdealer';
import './plugins/paroller.js';
import Stickybits from 'stickybits';

// check if an element is in viewport
// http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
var isElementInViewport = function(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

var initRevealEffect = function() {
  // define variables
  var items = document.querySelectorAll('.timeline-item__content');

  var callbackFunc = function() {
    for (var i = 0; i < items.length; i++) {
      if (isElementInViewport(items[i])) {
        items[i].classList.add('in-view');
      } else {
        items[i].classList.remove('in-view');
      }
    }
  };

  // listen for events
  window.addEventListener('load', callbackFunc);
  window.addEventListener('resize', callbackFunc);
  window.addEventListener('scroll', callbackFunc);
};

var scrollPage = function(offset, callback) {
  callback = typeof callback !== 'undefined' ? callback : null;
  $('html, body').animate(
    {
      scrollTop: offset
    },
    400,
    'swing',
    callback
  );
};

var initScrollbar = function() {
  var items = $('.timeline-item');
  var itemsAmount = items.length - 1;
  var currentStep = 0;
  var isScrolling = false;

  var controller = new Dragdealer('timeline-controller', {
    horizontal: false,
    vertical: true,
    handleClass: 'timeline-controller__handle',
    steps: items.length,
    animationCallback: function(x, y) {
      currentStep = Math.round(y * itemsAmount);
      var $currentItem = $(items[currentStep]);
      var currentYear = $currentItem.data('year');
      $('.timeline-controller__handle__value').text(currentYear);
    },
    dragStopCallback: function(x, y) {
      isScrolling = true;
      currentStep = Math.round(y * itemsAmount);
      var $currentItem = $(items[currentStep]);
      var currentOffset = $currentItem.offset().top;

      $('html, body').animate(
        {
          scrollTop: currentOffset
        },
        400,
        'swing',
        function() {
          isScrolling = false;
        }
      );
    }
  });

  var itemsContent = $('.timeline-item__content');

  var setController = function() {
    if (!isScrolling) {
      for (var i = 0; i < itemsContent.length; i++) {
        if (isElementInViewport(itemsContent[i])) {
          if (i !== currentStep) {
            currentStep = i;
            controller.setStep(0, i + 1);
          }
        }
      }
    }
  };

  window.addEventListener('resize', setController);
  window.addEventListener('scroll', setController);
};

var initYearSearch = function() {
  $('.timeline-search').on('submit', function(e) {
    e.preventDefault();

    var decade = $(this)
      .find('select')
      .val();

    var selectedItem = $(
      '.timeline-item[data-decade="' + decade + '"]'
    ).first();

    $('html, body').animate(
      {
        scrollTop: selectedItem.offset().top
      },
      400,
      'swing'
    );

    return false;
  });
};

var initClickEvents = function() {
  //Scroll to the first timeline item

  $('.timeline-explore').on('click', function() {
    var offset = $('.timeline').offset().top;
    scrollPage(offset);
  });

  //scroll to top of timeline
  $('.timeline-controller-top').on('click', function() {
    var offset = $('.timeline').offset().top;
    scrollPage(offset);
  });

  //scroll to bottom of timeline
  $('.timeline-controller-bottom').on('click', function() {
    var offset = $('.timeline').offset().top + $('.timeline').height();
    scrollPage(offset);
  });
};

var initFadeEffect = function() {
  var setFadeClass = function() {
    var windowTop = $(window).scrollTop();
    var offsetTop = $('.timeline').offset().top - $(window).height() / 2;

    if (windowTop > offsetTop) {
      $('.campaign-100-years').addClass('is-blurred');
    } else {
      $('.campaign-100-years').removeClass('is-blurred');
    }
  };

  window.addEventListener('resize', setFadeClass);
  window.addEventListener('scroll', setFadeClass);
};

$(document).ready(function() {
  if ($('.campaign-100-years').length > 0) {
    initRevealEffect();
    initScrollbar();
    initYearSearch();
    initClickEvents();
    initFadeEffect();

    //Parallax
    //First set the proper initial position (so the image looks whole)
    $('.timeline-parallax').each(function() {
      var $this = $(this);
      var offset = $this.offset().top;
      var factor = $this.data('paroller-factor');
      var setPosition = Math.round(offset * factor);

      $this.css({
        '-webkit-transform': 'translateY(' + setPosition + 'px)',
        '-moz-transform': 'translateY(' + setPosition + 'px)',
        '-ms-transform': 'translateY(' + setPosition + 'px)',
        '-o-transform': 'translateY(' + setPosition + 'px)',
        transform: 'translateY(' + setPosition + 'px)'
      });
    });
    // Then initialize the parallax
    $('.timeline-parallax').paroller();

    // position sticky polyfill
    Stickybits('.timeline-controller-content', {noStyles: true});
  }
});

$(window).on('load', function() {
  if ($('.campaign-100-years').length > 0) {
    setTimeout(function() {
      $('.campaign-100-years').removeClass('preload');
    }, 1100);
  }
});
